module.exports = __webpack_public_path__ + "img/icon-email.89ec68f0.svg";